import RemoveDocumentButton from "@ui-kit/form/RemoveDocumentButton/RemoveDocumentButton.web";
import { Text, Box, Flex } from "@chakra-ui/react";
import { formatFileSize } from "@shared/utils/file-utils/utils";
import { GenericUploadInputPropsType } from "./GenericUploadInput.props";
import { useGenericUploadInput } from "./useGenericUploadInput";

// Component is designed to support uploading only 1 document
const GenericUploadInput = ({
  removeButtonIcon = undefined,
  aspectRatio = 1, // show image as a square on upload component if not set
  ...props
}: GenericUploadInputPropsType) => {
  const { document, dropzoneIcon, helpText, id, subHelpText, currentFile } =
    props;

  const { getRootProps, getInputProps, isDragActive, removeDocument } =
    useGenericUploadInput(props);

  return (
    <>
      {!document && (
        <Flex
          {...getRootProps()}
          data-testid="upload-file-input"
          width="100%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          // eslint-disable-next-line showpass-custom/no-hardcoded-style-values -- TODO: Add size token for upload dropzone height
          height="224px"
          padding="lg"
          border="1.5px dashed"
          backgroundColor={isDragActive ? "blue.200" : "gray.200"}
          borderColor={isDragActive ? "blue.600" : "gray.400"}
          borderRadius="sm"
          _hover={{
            backgroundColor: "gray.300",
            borderColor: "gray.500",
          }}
        >
          <input {...getInputProps()} id={id} />

          {dropzoneIcon}

          {helpText && (
            <Text fontSize="md" mb="2xs" color="font.dark">
              {helpText}
            </Text>
          )}

          {subHelpText && (
            <Text fontSize="md" mb="lg" color="gray.500" textAlign="center">
              {subHelpText}
            </Text>
          )}
        </Flex>
      )}

      <Box data-testid="remove-document-button" width="100%">
        {document && (
          <RemoveDocumentButton
            customIcon={removeButtonIcon} // this will overwrite the src param
            src={document}
            title={currentFile?.name || ""}
            subTitle={currentFile?.size ? formatFileSize(currentFile.size) : ""}
            onClick={removeDocument}
            aspectRatio={aspectRatio}
          />
        )}
      </Box>
    </>
  );
};

export default GenericUploadInput;
